import type { WindowDescriptor } from '@krp/client-runtime'
import type { ReceiptsUiState } from '../../reducer'
import { cashierAnalyticsPatched, decodeCashierAnalyticsIntent } from './model/analyticsSlice'

/** Таб «Кассиры» раздела «Статистика по продажам» (RP-STAT-UNIFY): отдельного раздела «Статистика кассира» нет. */
export const CASHIER_ANALYTICS_WINDOWS = { statistics: 'receipts.cashierAnalytics.statistics' } as const
const capture = (state: ReceiptsUiState) => ({ intent: state.cashierAnalytics })
const restore = (snapshot: Record<string, unknown>) => { const value = decodeCashierAnalyticsIntent(snapshot.intent); return value === undefined ? [] : [cashierAnalyticsPatched(value)] }
export const cashierAnalyticsWindows: readonly WindowDescriptor<ReceiptsUiState>[] = [
  { kind: CASHIER_ANALYTICS_WINDOWS.statistics, scope: 'global', paths: ['/sales-statistics/cashiers'], label: 'Кассиры', presentation: 'page', section: { id: 'sales-statistics' }, capture, restore },
]
